import '../../styles/game/GameRules.css';
import '../../styles/game/ProvablyFairSettings.css';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';



function ProvablyFair({ isOpen, onClose, ProvablyFairOpen, ProvablyOpen }) {
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();
    const [isRandomActive, setIsRandomActive] = useState(true);
    const [isManuallyActive, setIsManuallyActive] = useState(false);
    const randomClick = () => {
        if (isRandomActive) {
            return
        }
        if(isManuallyActive) {
            setIsManuallyActive(false);
        }
        setIsRandomActive(true);
    }

    const manuallyClick = () => {
        if(isManuallyActive) {
            return
        }

        if(isRandomActive) {
            setIsRandomActive(false);
        }
        setIsManuallyActive(true);
    }
    useEffect(() => {
        if (isOpen) {
            setTimeout(() => setIsVisible(true), 10);
        } else {
            setIsVisible(false);
        }
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);


    return (
        <>
            <div className={`modalWrapper ${isVisible ? "show" : "fade-out"}`}
                 onClick={() => {
                     setTimeout(() => setIsVisible(false), 10);
                     onClose();
                 }}>
            </div>
            <div className={`gameRulesModal ${isVisible ? "show" : "fade-out"}`} onClick={() => {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }}>
                <div className={`provablyFairSettings ${isVisible ? "show" : "fade"}`}>
                    <div className={'gameRulesContent'} onClick={(e) => e.stopPropagation()}>
                        <div className={'gameRulesHeader'}>
                            <span>{t("provablyFairSettings").toUpperCase()}</span>
                            <button className={'gameRulesCloseBtn'} onClick={() => {
                                setTimeout(() => setIsVisible(false), 10);
                                onClose();
                            }}>
                                <span>×</span>
                            </button>
                        </div>
                        <div className={'provablyFairSettingsBody'}>
                            <div className={'pfs-info'}>
                                <p>{t("pfsItem1")}</p>
                                <p className={'pfs-info-link'} onClick={ProvablyOpen}>
                                    <div></div>
                                    {t("pfsItem2")}
                                </p>
                            </div>
                            <div className={'client-seed'}>
                                <div className={'client-seed-title'}>
                                    <div className={'client-seed-title-main'}>
                                        <div></div>
                                        <span>{t("pfsItem3")}</span>
                                    </div>
                                    <div className={'client-seed-title-sub'}>
                                        <span>{t("pfsItem4")}</span>
                                    </div>
                                </div>
                                <div className={`client-seed-type ${isRandomActive ? "active" : ""}`}>
                                    <div className={'client-seed-type-wrap'} onClick={randomClick}>
                                        <span className={'client-seed-radio'}>
                                            <div className={'radio-dot'}></div>
                                        </span>
                                        <span>{t("pfsItem5")}</span>
                                    </div>
                                    <div className={'random-block-key'}>
                                        <div className={'key-container-random'}>
                                            <div className={'key-random'}>
                                                <p>
                                                    <span className={'current-key-text'}>{t("pfsCurrent")}</span>
                                                    <span>JdxdSKFnfyBLzmxP903S</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`client-seed-type ${isManuallyActive ? "active" : ""}`}>
                                    <div className={'client-seed-type-wrap'} onClick={manuallyClick}>
                                        <span className={'client-seed-radio'}>
                                            <div className={'radio-dot'}></div>
                                        </span>
                                        <span>{t("pfsItem6")}</span>
                                    </div>
                                    <div className={'manually-block-key'}>
                                        <div className={'key-container-manually'}>
                                            <div className={'key-random'}>
                                                <p>
                                                    <span className={'current-key-text'}>{t("pfsCurrent")}</span>
                                                    <span className={'white-text'}>JdxdSKFnfyBLzmxP903S</span>
                                                </p>
                                            </div>
                                        </div>
                                        <button className={'manually-button'}>
                                            <span>{t("pfsChange")}</span>
                                        </button>
                                    </div>

                                </div>
                            </div>
                            <div className={'server-seed'}>
                                <div className={'server-seed-title'}>
                                    <div></div>
                                    <span>{t("pfsItem7")}</span>
                                </div>
                                <div className={'server-seed-value-block'}>
                                    <div className={'server-seed-key-container'}>
                                        <div className={'server-seed-key'}>
                                            86587ff3ec6cd5ec4673824014d20844a444589b2f5a2b404c7248a730ef82a7
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'provablyFairSettingsFooter'}>
                            {t("pfsItem8")}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProvablyFair;